const Styles = {
  underlineFocusStyle: {
    borderColor: '#42a5f5',
  },
  floatingLabelStyle: {
    color: '#42a5f5',
    lineHeight: '10px',
  },
  floatingLabelFocusStyle: {
    color: '#42a5f5',
    lineHeight: '10px',
  },
};

export default Styles;



// WEBPACK FOOTER //
// ./src/styles/Styles.js